import { createUseThemeHook } from 'legos/theme';

declare module 'legos/theme' {
  interface BulkLegoTheme {
    newpassword: NewPasswordTheme;
  }
}

export interface NewPasswordTheme {
  neutral: string;
  negative: string;
  positive: string;
  labelColor: string;
}

const [NewPasswordThemeProvider, useNewPasswordTheme] = createUseThemeHook(
  'newpassword',
  (global): NewPasswordTheme => ({
    neutral: global.neutral.color200,
    negative: global.negative.color500,
    positive: global.positive.color500,
    labelColor: global.neutral.color700
  })
);

export { NewPasswordThemeProvider, useNewPasswordTheme };
